export const BRAND = 'Estimator';
export const FORMAT_LOCALE = 'en-US';
export const DEFAULT_CURRENCY_SIGN = '$';
export const DEFAULT_ESTIMATION_PLACEHOLDER = 'Check Files';

export const MIN_QUANTITY = 0;
export const MIN_PERCENT = 0;
export const MAX_PERCENT = 100;
export const MAX_NAME = 200;
export const MIN_PASSWORD = 6;
export const MAX_PASSWORD = 100;
export const USERS_PREVIEW_LIMIT = 6;
export const ESTIMATOR_TOKEN_MULTIPLIER = 10000;

export const EMPTY_DATA = '';
export const ZERO_STRING = '0';
export const COMMA_SEPARATOR = ',';
export const EXCLUSIVE_MODAL_OPENED_EVENT = 'exclusive-modal-opened';
export const PERCENT = '%';
export const SELECT_VARIANT = 'neumorphic';
